"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE = exports.IMAGE_URL = exports.IMAGE_NOT_FOUND = exports.IMAGE = exports.COLOR = exports.ALIGN = void 0;
var SIZE = {
  medium: 'medium',
  default: 'default',
  titleNormal: 'titleNormal',
  textSmall: 'textSmall',
  small: 'small'
};
exports.SIZE = SIZE;
var COLOR = {
  green: 'green',
  greenLight: 'greenLight',
  greyDark: 'greyDark',
  greyDarker: 'greyDarker',
  tertiary: 'tertiary',
  neutral: 'neutral'
};
exports.COLOR = COLOR;
var IMAGE_NOT_FOUND = 'NO Image Fount';
exports.IMAGE_NOT_FOUND = IMAGE_NOT_FOUND;
var ALIGN = {
  center: 'center'
};
exports.ALIGN = ALIGN;
var IMAGE_URL = 'https://images.trvl-media.com/hotels/2000000/1830000/1823800/1823707/64563298_z.jpg';
exports.IMAGE_URL = IMAGE_URL;
var IMAGE = {
  width: '240px',
  height: '150px'
};
exports.IMAGE = IMAGE;